import { stylesheet } from 'typestyle';

import { FontsRaw, Spacing } from '../styles';

export const SearchContainerStyles = (isHome: boolean) => {
  const styles = stylesheet({
    container: {
      /*** maxWidth based on mozilla protocol large cards size; see https://protocol.mozilla.org/components/detail/card--large
       ***/
      maxWidth: '973px',
      marginTop: isHome ? `${Spacing.layoutLarge + 20}px` : '0px',
      margin: '0 auto',
      marginBottom: isHome ? '0px' : `${Spacing.xxLarge}px`,
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      $nest: {
        '.search-default-title': {
          ...FontsRaw.HeadingXS,
          marginBottom: `${Spacing.xLarge + 10}px`,
          textAlign: 'center',
        },
      },
    },
  });

  return styles;
};
